import { z } from 'zod';

/**
 * Student activity events. Anonymous by design: no names, emails or IPs are collected.
 * `sid` is a random id generated in the browser for the visit.
 */
export const EVENT_TYPES = [
  'page_view',
  'search',
  'filter',
  'favorite_add',
  'favorite_remove',
  'unit_open',
  'join_click',
  'webinar_click',
  'pdf_open',
  'video_open',
  'consult_open',
  'consult_join',
  'calendar_add',
  'fair_video_play',
] as const;
export const EventTypeSchema = z.enum(EVENT_TYPES);
export type EventType = z.infer<typeof EventTypeSchema>;

export const ActivityEventSchema = z.object({
  type: EventTypeSchema,
  /** Client timestamp, ms since epoch, already corrected for the server clock offset. */
  ts: z.number(),
  sid: z.string().min(8).max(64),
  /** Fair state when the event happened. */
  phase: z.enum(['before', 'keynote', 'sessions', 'ended']).optional(),
  unitId: z.string().max(64).optional(),
  /** Search text, filter value or link label. Truncated server-side as well. */
  value: z.string().max(200).optional(),
  /** Which data snapshot the client was showing. */
  dataVersion: z.string().max(64).optional(),
});
export type ActivityEvent = z.infer<typeof ActivityEventSchema>;

export const MAX_BATCH = 100;
export const EventBatchSchema = z.object({
  events: z.array(ActivityEventSchema).min(1).max(MAX_BATCH),
});
export type EventBatch = z.infer<typeof EventBatchSchema>;
